import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { useTranslation } from "react-i18next";
import { z } from "zod";

const client = "n1";
const table_name = "n1_events";
const static_data_table_name = "n1_static_data";

const filterN1EventsSchema = z.object({
  n1_static_datum_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  event_equal: z.string().optional().nullable(),
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  create_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  create_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterN1EventsSchema = z.infer<typeof filterN1EventsSchema>;

export function FilterN1Events() {
  const { t, i18n } = useTranslation("tables");

  const fields: Field[] = [
    {
      name: "n1_static_datum_name_contains",
      label: t(`${table_name}.columns.n1_static_datum_name`, {
        defaultValue: "Asset",
      }),
      type: "asyncAutocomplete",
      base_url: `${client}/${static_data_table_name}`,
      column_name: "name",
    },
    {
      name: "event_equal",
      label: t(`${table_name}.columns.event`, {
        defaultValue: "Event type",
      }),
      type: "select",
      useTranslation: true,
      client: "n1",
      table_name: "n1_events",
      language: i18n.resolvedLanguage?.startsWith("fr") ? "fr" : "en",
      translate_key: "event",
    },
    {
      name: "date",
      type: "dateRange",
      label: t(`${table_name}.columns.date`, {
        defaultValue: "Date",
      }),
      from: { name: "date_from" },
      to: { name: "date_to" },
      col_span: 2,
    },
    {
      name: "create",
      type: "dateRange",
      label: t(`${table_name}.columns.created_at`, {
        defaultValue: "Created at",
      }),
      from: { name: "create_from" },
      to: { name: "create_to" },
      col_span: 2,
    },
  ];

  return (
    <FilterTable
      columns={2}
      client={client}
      schema={filterN1EventsSchema}
      tableName={table_name}
      fields={fields}
    />
  );
}
